import TrialRetouchMagicWandRebrand from '@/assets/image/free-to-pay/trial-retouch-magic-wand-svg/trial-retouch-magic-wand-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const TrialRetouchMagicWand = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'together tier', ...rest } = props;

  return <Image src={TrialRetouchMagicWandRebrand} alt={alt} {...rest} />;
};
